import { useEffect } from 'react';
import { withSiteMeta } from '../HOCS/withSiteMeta';

// inject the reamaze widget programmatically
export const ReamazeWidget = withSiteMeta((props: any) => {
  useEffect(() => {
    if (props.siteConfig.enableReamaze) {
      const script = document.createElement('script');
      script.src = 'https://cdn.reamaze.com/assets/reamaze.js';
      script.id = 'reamaze-widget-script';
      document.body.appendChild(script);
    }

    return () => {
      const script = document.getElementById('reamaze-widget-script');
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [props.siteConfig.enableReamaze]);

  return null;
});
